export default defineAppConfig({
  ui: {
    colors: {
      primary: 'aris',
      secondary: 'industrial',
      neutral: 'zinc'
    },
    button: {
      slots: {
        base: ['active:scale-95']
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class: 'hover:shadow-primary-md hover:bg-primary/90'
        },
        {
          color: 'primary',
          variant: 'outline',
          class: 'hover:shadow-primary-sm ring-primary/20 hover:ring-primary/50'
        },
        {
          color: 'primary',
          variant: 'outlinedashed',
          class: 'hover:shadow-primary-sm border-dashed border border-primary/20 hover:bg-primary/10 hover:border-primary/60'
        },
        {
          color: 'error',
          variant: 'solid',
          class: 'hover:shadow-destructive'
        },
      ]
    },
    input: {
      compoundVariants: [
        {
          color: 'primary',
          highlight: true,
          class: 'ring-primary/20'
        },
        {
          color: 'primary',
          variant: 'outline',
          class: 'bg-transparent'
        },
      ]
    },
    alert: {
      slots: {
        description: '[&>p]:mb-0'
      }
    },
    tabs: {
      variants: {
        color: {
          ams: {
            list: 'border border-primary/10 bg-muted/70',
            indicator: 'bg-primary/10',
            trigger: 'data-[state=active]:text-primary',
          },
          outline: {
            list: 'border border-primary/10 bg-muted/50!',
            indicator: 'bg-white/10',
            trigger: 'data-[state=active]:text-primary',
          }
        }
      }
    }
  }
})
